import { render, staticRenderFns } from "./RepeatSummary.vue?vue&type=template&id=20fe4e0e&"
import script from "./RepeatSummary.vue?vue&type=script&lang=js&"
export * from "./RepeatSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20fe4e0e')) {
      api.createRecord('20fe4e0e', component.options)
    } else {
      api.reload('20fe4e0e', component.options)
    }
    module.hot.accept("./RepeatSummary.vue?vue&type=template&id=20fe4e0e&", function () {
      api.rerender('20fe4e0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Repeat/RepeatSummary.vue"
export default component.exports